export default {
    GAM_FIRMWARE_TIMEOUT: 180,
    GAM_UPDATE_SETTING_TIMEOUT: 60,
    GAM_SYNC_TIMEOUT: 60,
    GAM_CHECK_STATUS_INTERVAL: 2,
    GAM_WAIT_ASSET_TIMEOUT: 10,
    GAM_GIGYA_REFRESH_TOKEN_TIMEOUT: 10,
    GAM_WS_RECONNECT_TIMEOUT: 5,
};
